import { connectionsConstants } from "../_constants";

export function connectionsList(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.GET_ALL_CONNECTIONS_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.GET_ALL_CONNECTIONS_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.GET_ALL_CONNECTIONS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function connectionsTopCard(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.GET_TOP_CARDS_CONNECTIONS_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.GET_TOP_CARDS_CONNECTIONS_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.GET_TOP_CARDS_CONNECTIONS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeSourceDestination(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.GET_FETCH_ACTIVE_SOURCE_DESTINATION_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.GET_FETCH_ACTIVE_SOURCE_DESTINATION_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.GET_FETCH_ACTIVE_SOURCE_DESTINATION_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function connection(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.ADD_CONNECTION_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.ADD_CONNECTION_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.ADD_CONNECTION_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function connectionById(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.GET_CONNECTION_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.GET_CONNECTION_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.GET_CONNECTION_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function connectionByWorkspaceId(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.GET_CONNECTION_BY_WORKSPACE_ID_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.GET_CONNECTION_BY_WORKSPACE_ID_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.GET_CONNECTION_BY_WORKSPACE_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function endPointsByConnectionId(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.GET_ENDPOINTS_BY_CONNECTION_ID_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.GET_ENDPOINTS_BY_CONNECTION_ID_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.GET_ENDPOINTS_BY_CONNECTION_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function configureConnection(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.CONFIGURE_CONNECTION_BY_CONNECTION_ID_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.CONFIGURE_CONNECTION_BY_CONNECTION_ID_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.CONFIGURE_CONNECTION_BY_CONNECTION_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function editConnection(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.EDIT_CONNECTION_BY_ID_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.EDIT_CONNECTION_BY_ID_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.EDIT_CONNECTION_BY_ID_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function slackListIntegration(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.FETCH_SLACK_LIST_INTEGRATION_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.FETCH_SLACK_LIST_INTEGRATION_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.FETCH_SLACK_LIST_INTEGRATION_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function bitbucketListIntegration(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.FETCH_BITBUCKET_INTEGRATION_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.FETCH_BITBUCKET_INTEGRATION_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.FETCH_BITBUCKET_INTEGRATION_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function connectionsFilters(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.GET_CONNECTIONS_FILTERS_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.GET_CONNECTIONS_FILTERS_SUCCESS:
      return {
        items: action.data,
      };
    case connectionsConstants.GET_CONNECTIONS_FILTERS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeConnection(state = {}, action) {
  switch (action.type) {
    case connectionsConstants.ACTIVATE_CONNECTION_REQUEST:
      return {
        loading: true,
      };
    case connectionsConstants.ACTIVATE_CONNECTION_SUCCESS:
      return {
        item: action.data,
      };
    case connectionsConstants.ACTIVATE_CONNECTION_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
